import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    reportViewType: {
      display: 'flex',
      alignItems: 'center',
    },
    radioInputs: {
      '&.MuiFormGroup-root': {
        gap: theme.spacing(2),
        marginLeft: theme.spacing(3),
      },
    },
  }),
);
